import React from 'react';
import {Card} from "../../../../components/card/card.jsx";
import {FaLock, FaUser} from "react-icons/fa";
import InputForm from "../../../../components/input/input-form.jsx";
import InputPassword from "../../../../components/input/input-password.jsx";
import Button from "../../../../components/button/button.jsx";
import {getAssetPath} from "../../../../utils/get-asset-path.js";

const API_URL = import.meta.env.VITE_API_URL;

const LoginCard = ({form, onChange, onSubmit, errorMessage, cityName, loading, loginBlocked, onResetPassword, onOpenSupport}) => {
    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit();
    };

    const handleImageError = (e) => {
        e.currentTarget.onerror = null;
        e.currentTarget.src = getAssetPath("img/sentry-logo3.png");
    };

    return (
        <Card className="w-[420px] max-w-full p-7">
            <Card.Body className={"p-0!"}>
                <div className="flex flex-col items-center mb-4">
                    <img
                        src={`${API_URL}/corporation/entity/image`}
                        alt={cityName || "Sentry"}
                        className="max-h-[125px] object-contain"
                        onError={handleImageError}
                    />
                    {cityName && <p className="m-0 mt-2 font-bold uppercase text-gray-700 text-[16px] text-center">{cityName}</p>}
                </div>

                {
                    errorMessage &&
                    <p className="text-center text-[#ed5565] text-[16px] mb-3">{errorMessage}</p>
                }

                <form className="space-y-5" onSubmit={handleSubmit}>
                    <InputForm
                        id="username"
                        name="username"
                        inputClass="uppercase"
                        label={<span className="flex gap-2 items-center"><FaUser/> Usuário</span>}
                        value={form.username}
                        onChange={onChange}
                        autofocus
                    />

                    <InputPassword
                        id="password"
                        name="password"
                        label={<span className="flex gap-2 items-center"><FaLock/> Senha</span>}
                        value={form.password}
                        onChange={onChange}
                    />

                    <Button target="success" className="w-full" type="submit" loading={loading} loadingText="Entrando..." disabled={loginBlocked}>
                        Entrar
                    </Button>
                </form>

                <p
                    className="text-center text-[16px] text-[#1f75cb] mt-4 cursor-pointer hover:underline"
                    onClick={onResetPassword}
                >
                    Primeiro acesso ou recuperação de senha
                </p>

                <hr className="my-5! text-gray-300"/>

                <Button target="primary-outline" className="w-full !text-[12px]" onClick={onOpenSupport}>
                    Suporte Técnico
                </Button>
            </Card.Body>
        </Card>
    );
};

export default LoginCard;
